module.exports = __webpack_public_path__ + "Icono_Historial_Material.png";